import { Link } from 'react-router-dom';
import { styles, useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkButton = ({
  to,
  small,
  block,
  children,
  ...rest
}) => {
  const styles = useStyles(linkButtonStyles, {}, {
    '&small': Boolean(small),
    '&block': Boolean(block)
  });
  if (!to) {
    return /*#__PURE__*/_jsx("a", {
      role: "button",
      ...styles,
      ...rest,
      children: children
    });
  }
  return (
    /*#__PURE__*/
    // @ts-ignore SIGPG-3562
    _jsx(Link, {
      ...styles,
      to: to,
      ...rest,
      children: children
    })
  );
};
const linkButtonStyles = ({
  font,
  lineHeight,
  padding
}) => {
  const height = styles.calculateHeight(font.size.normal, lineHeight, padding.small);
  const smallHeight = styles.calculateHeight(font.size.small, lineHeight, padding.xsmall);
  return {
    display: 'inline-block',
    fontSize: font.size.button,
    lineHeight: `${height}px`,
    verticalAlign: 'middle',
    borderRadius: 0,
    textDecoration: 'none',
    cursor: 'pointer !important',
    '&block': {
      display: 'block',
      width: '100%'
    },
    '&disabled': {
      opacity: 0.65,
      cursor: 'default'
    },
    '&small': {
      fontSize: font.size.small,
      lineHeight: `${smallHeight}px`,
      height: smallHeight,
      minWidth: smallHeight
    }
  };
};
export default LinkButton;